import React from "react";
import {
  Truck,
  PackageCheck,
  Store,
  CreditCard,
  HandCoins,
  Wallet,
  RotateCw,
} from "lucide-react";

const DeliveryPage = () => {
  return (
    <div className="container mx-auto px-4 py-10">
      <h1 className="text-3xl sm:text-4xl font-bold mb-8 text-center text-gray-800">
        Условия доставки и оплаты
      </h1>

      {/* Доставка */}
      <section className="mb-12">
        <h2 className="text-2xl font-semibold mb-6 flex items-center text-gray-800">
          <Truck className="w-6 h-6 mr-2 text-blue-500" />
          Варианты доставки
        </h2>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          <div className="bg-white shadow rounded-xl p-6 flex flex-col items-center text-center">
            <PackageCheck className="w-10 h-10 text-green-500 mb-3" />
            <h3 className="text-xl font-semibold mb-2">Доставка автотранспортом</h3>
            <p className="text-gray-600 text-sm">
              Доставка металлопроката и стройматериалов специализированным транспортом по городу и области.
            </p>
          </div>
          <div className="bg-white shadow rounded-xl p-6 flex flex-col items-center text-center">
            <Truck className="w-10 h-10 text-orange-500 mb-3" />
            <h3 className="text-xl font-semibold mb-2">Доставка в регионы</h3>
            <p className="text-gray-600 text-sm">
              Отгрузка в любые регионы России через транспортные компании. Поможем организовать логистику.
            </p>
          </div>
          <div className="bg-white shadow rounded-xl p-6 flex flex-col items-center text-center">
            <Store className="w-10 h-10 text-purple-500 mb-3" />
            <h3 className="text-xl font-semibold mb-2">Самовывоз со склада</h3>
            <p className="text-gray-600 text-sm">
              Вы можете самостоятельно забрать заказ со склада в удобное для вас время.
            </p>
          </div>
        </div>
      </section>

      {/* Оплата */}
      <section className="mb-12">
        <h2 className="text-2xl font-semibold mb-6 flex items-center text-gray-800">
          <CreditCard className="w-6 h-6 mr-2 text-blue-500" />
          Способы оплаты
        </h2>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          <div className="bg-white shadow rounded-xl p-6 flex flex-col items-center text-center">
            <CreditCard className="w-10 h-10 text-indigo-600 mb-3" />
            <h3 className="text-xl font-semibold mb-2">Безналичная оплата</h3>
            <p className="text-gray-600 text-sm">
              Оплата по счёту для юридических и физических лиц. Выставим счёт и предоставим все документы.
            </p>
          </div>
          <div className="bg-white shadow rounded-xl p-6 flex flex-col items-center text-center">
            <HandCoins className="w-10 h-10 text-yellow-500 mb-3" />
            <h3 className="text-xl font-semibold mb-2">Оплата наличными</h3>
            <p className="text-gray-600 text-sm">
              Возможна оплата наличными при самовывозе с нашего склада.
            </p>
          </div>
          <div className="bg-white shadow rounded-xl p-6 flex flex-col items-center text-center">
            <Wallet className="w-10 h-10 text-pink-500 mb-3" />
            <h3 className="text-xl font-semibold mb-2">Онлайн-оплата</h3>
            <p className="text-gray-600 text-sm">
              Поддерживаем оплату через банковские карты и электронные платёжные системы.
            </p>
          </div>
        </div>
      </section>

      {/* Возврат */}
      <section className="mb-12">
        <h2 className="text-2xl font-semibold mb-6 flex items-center text-gray-800">
          <RotateCw className="w-6 h-6 mr-2 text-red-500" />
          Возврат товара
        </h2>
        <div className="bg-white shadow rounded-xl p-6">
          <p className="text-gray-700 text-base leading-relaxed">
            Вы можете вернуть товар надлежащего качества в течение{" "}
            <span className="font-semibold text-gray-900">14 дней</span> с момента получения. Важно, чтобы продукция не использовалась и сохранила товарный вид.
          </p>
        </div>
      </section>
    </div>
  );
};

export default DeliveryPage;
